import React from "react";
import { ImagePictureAddPlusIcon } from "../../icons/ImagePictureAddPlusIcon";
import { VideoPlaceHolderIcon } from "../../icons/VideoPlaceHolderIcon";
import { CodeTextIcon } from "../../icons/CodeTextIcon";
import { ElementType } from "../../types";
const ElementPlaceholderIcon = {
  [ElementType.Image]: ImagePictureAddPlusIcon,
  [ElementType.Video]: VideoPlaceHolderIcon,
  [ElementType.Embed]: CodeTextIcon
};
export const ElementPlaceholder = ({
  elementType
}) => {
  const Component = ElementPlaceholderIcon[elementType];
  if (!Component) return null;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "6px",
      border: "1px solid",
      borderColor: "#D0D5DD",
      backgroundColor: "#F2F4F7",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "8px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "100%",
      border: "1px solid",
      borderColor: "#D0D5DD",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
    }
  }, /*#__PURE__*/React.createElement(Component, {
    size: "20px"
  })));
};
//# sourceMappingURL=ElementPlaceholder.js.map